const KITCHEN_SESSION_KEY = 'superoti.kitchen.session'

export type KitchenSession = {
  accessToken: string
  userId: string
  userName: string
  role: 'HEAD_KITCHEN' | 'STAFF_KITCHEN'
  loggedInAt: string
}

export function getKitchenSession(): KitchenSession | null {
  try {
    const raw = localStorage.getItem(KITCHEN_SESSION_KEY)
    if (!raw) return null
    return JSON.parse(raw) as KitchenSession
  } catch {
    return null
  }
}

export function hasKitchenSession(): boolean {
  return getKitchenSession() !== null
}

export function setKitchenSession(session: KitchenSession): void {
  localStorage.setItem(KITCHEN_SESSION_KEY, JSON.stringify(session))
}

export function clearKitchenSession(): void {
  localStorage.removeItem(KITCHEN_SESSION_KEY)
}
